import zionDebug from '@fs/zion-debug'

import * as routes from './index'

const debug = zionDebug('apac:getRegionRoutes')

/**
 * Returns the region specific routes for the given site
 * @param {keyof typeof routes} site The site name
 * @returns {React.ReactNode[]} The region specific routes
 */
export default function getRegionRoutes(site) {
  const siteRoutes = routes[site] || []
  debug(`site "${site}" has ${siteRoutes.length} routes`)
  return siteRoutes
}
